import React from 'react';
import { Link } from 'react-router-dom';

const serviceCardsData = [
  {
    image: 'assets/images/services/services-1-1.png',
    icon: 'icon-car',
    title: 'Auto Car Loan',
    text: 'Flexible financing for vehicles. Competitive rates for your dream car.',
  },
  {
    image: 'assets/images/services/services-1-2.png',
    icon: 'icon-diamond',
    title: 'Wedding Loan',
    text: 'Have your dream wedding. Wedding loans provide customized financing to help pay for your special day from venue to catering.',
  },
  {
    image: 'assets/images/services/services-1-3.png',
    icon: 'icon-house',
    title: 'Property Loan',
    text: 'Low down mortgages and great rates simplify buying your dream home.',
  },
  {
    image: 'assets/images/services/services-1-4.png',
    icon: 'icon-briefcase',
    title: 'Business Loan',
    text: 'Tailored financing helps companies expand and grow their business.',
  },
  {
    image: 'assets/images/services/services-1-5.png',
    icon: 'icon-book',
    title: 'Education Loan',
    text: 'Fund your future. Our education loans provide financing options to help you pay for college, vocational programs, and continuing education.',
  },
  {
    image: 'assets/images/services/services-1-6.png',
    icon: 'icon-user',
    title: 'Personal Loan',
    text: 'Get funds fast. Personal loans offer quick financing for major purchases, life events, debt consolidation, and more.',
  },
];

const First = () => {
  return (
    <>
      <section className="service-grid pt-120 pb-140">
        <div className="container">
          <div className="row row-gutter-y-50">
            {serviceCardsData.map((card, index) => (
              <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
                <div className="service-card">
                  <div className="service-card__image">
                    <img src={card.image} alt={card.title} />
                    <Link to="/servicedetails"></Link>
                  </div>
                  <div className="service-card__content">
                    <div className="service-card__content__inner">
                      <div className="service-card__icon">
                        <i className={card.icon}></i>
                      </div>
                      <h3 className="service-card__title">
                        <Link to="/servicedetails">{card.title}</Link>
                      </h3>
                      <p className="service-card__text">{card.text}</p>
                      <Link to="/servicedetails" className="service-card__link">
                        <i className="fa fa-angle-right"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default First;
